import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen pt-16" data-testid="about-page">
      <section className="container mx-auto px-4 py-8 max-w-6xl">
        <h1 className="font-poetry text-4xl font-semibold mb-8 text-center" data-testid="about-title">
          About the Moose Verse
        </h1>
        
        <div className="prose prose-lg dark:prose-invert mx-auto space-y-6" style={{ maxWidth: '75ch' }}>
          <p className="italic text-center text-muted-foreground">
            <strong>Note:</strong> The Moose Verse Project is ephemeral by design. 
            Like a poem spoken aloud that lives only in the moment and memory, 
            this digital experience may disappear at any time. We invite you to 
            enjoy it while it exists.
          </p>

          <hr className="my-8" />

          <h2 className="font-poetry text-2xl font-semibold">What is Moose Verse?</h2>
          <p>
            Moose Verse is a playful, curious experiment at the intersection of 
            poetry and AI. It uses large language models to explore how different 
            poets might write about one unlikely but loyal muse: the moose.
          </p>
          
          <p className="italic text-muted-foreground">
            There are over 1500 poems with "moose" in them on <a href="https://www.poetryfoundation.org/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">poetryfoundation.org</a>.
          </p>

          <h2 className="font-poetry text-2xl font-semibold">What You'll Find Here</h2>
          <p>
            Everything in Moose Verse — the poems, the "style points," and the 
            "style highlights" — is generated by AI. The poems are created in 
            response to moose-themed prompts using stylistic patterns drawn from 
            literary analysis. Each poem aims to reflect characteristics of a 
            particular poetic style — not the personal inspiration of the poet 
            themselves, but elements that appear frequently in their work. Brief 
            "style points" summarize these traits, and "style highlights" annotate 
            the poems to show where the model has incorporated them.
          </p>
          
          <h2 className="font-poetry text-2xl font-semibold">What You Can Do Here</h2>
          <p>
            Browse the list of all the poet's included in the project and their style points. Find one that intrigues you and create a poem inspired by their style. Read through the Big Book of Poems and turn on highlights to see how style characteristics are expressed in text. (Hover or click on highlights to see details.) Read through eight short poems in a 'deathmatch' and get a sense for how different stylistic approaches develop in the text.
          </p>
          
          <h2 className="font-poetry text-2xl font-semibold">Why We're Doing This</h2>
          <p>
            This project celebrates the range and richness of poetic expression. 
            By comparing how different voices might treat the same moose-themed prompt, 
            we hope to spark interest in deeper exploration of poetry and style. 
            Links to poetryfoundation.org offer readers a way to learn more about each poet's work.
          </p>
          
          <h2 className="font-poetry text-2xl font-semibold">A Word of Respect</h2>
          <p>
            While the AI can approximate poetic styles, it cannot replicate the life, 
            experience, and intention behind real poetry. Moose Verse can offer new, 
            sometimes surprising artifacts in the style of great poets, but the true 
            depth of poetry is best found in the poets' own words.
          </p>
          
          <h2 className="font-poetry text-2xl font-semibold">Built with Curiosity and Code</h2>
          <p>
            Moose Verse is a project of MSW – MicroSaaSWreckage, a small digital 
            studio exploring creative tools and generative AI. It's built entirely 
            on synthetic data — and not a single line of code was written by a 
            human engineer. From generation to deployment, every piece of Moose 
            Verse was crafted with AI development tools. It's a light, fast, 
            and fun example of what can happen when you mix LLMs with literary 
            curiosity and a bit of antlered inspiration.
          </p>
        </div>
        
        <hr className="my-8 border-gray-300 dark:border-gray-700" />
        <p className="text-center text-sm text-muted-foreground">
          You can contact the creators of the Moose Verse project by sending email to mooseverse at proton dot me
        </p>
        
      </section>
    </div>
  );
};

export default About; 